import { createFileRoute } from '@tanstack/react-router'
import { Organization } from 'pages/organization/Organization'
import { z } from 'zod'

const searchParams = z.object({
  mode: z.enum(['create', 'edit']),
})

export const Route = createFileRoute('/organization')({
  component: Organization,
  staticData: {
    title: 'Organization',
  },
  validateSearch: searchParams,
  beforeLoad: ({ search }) => {
    const { mode } = search
    const pathSegments = window.location.pathname.split('/').filter(Boolean)

    // Reject edit if this is exactly /organization (no additional segments)
    if (mode === 'edit' && pathSegments.length === 1) {
      throw new Error(
        'Edit mode requires organization ID. Use /organization/{orgId}?mode=edit'
      )
    }
  },
})
